<!--
	作者：Shujuan Sun
	时间：2017-04-19
	描述：监控平台左侧多标签查车控件
-->
<template>
	<div>
		<!-- 车辆监控页面_左侧车辆列表模块开始   -->
		<div :class="{'minSizeL minBtnL':leftSize==0,'tab-vertical-left tab-vertical':leftSize!= 0,'activ_magnify':magnify,'midSizeL':leftSize==1,'maxSizeL':leftSize == 2}" class="tree-tab" style="z-index:1">
			<div class="tab-title" style="width:100%;" v-show="leftSize!=0">
				<div class="dropdown" data-toggle="tooltip" data-placement="bottom" title="显示菜单">
					<a id="dLabel" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i></i> </a>
					<ul class="dropdown_menu list-group list03" id="menuL" aria-labelledby="dLabel">
						<li class="list_group_item" v-for="(tab,index) in tabName" @click="goTab(index,tab)" :class="{active:curIndex===index}">{{tab}}</li>				
					</ul>
				</div>
				<span>{{tabTitle}}</span>
				<em @click="hidePanel" v-show="leftSize==1" class="downArrow" data-toggle="tooltip" data-placement="right" title="最大"></em> 
				<em @click="hidePanel" v-show="leftSize==2" class="upArrow" data-toggle="tooltip" data-placement="right" title="最小"></em>
				<em class="btn_shrink" v-show="magnify" @click="toShrink" data-toggle="tooltip" data-placement="right" title="缩小"></em><!--放大按钮-->
				<em class="btn_shrink" v-show="!magnify" @click="toMagnify" data-toggle="tooltip" data-placement="right" title="放大"></em><!--缩小按钮--> 
			</div>
			<div v-show="leftSize==0" @click="hidePanel" class="minSizeLTxt" data-toggle="tooltip" data-placement="right" title="半高">
				<span></span>
			</div>
			<div class="tab-header tab-search">
				<div id="btnUpL" class="btn1" @mousedown="topMouseDown" @mouseup="topMouseUp" data-toggle="tooltip" data-placement="bottom" title="上移"> </div>
				<div class="tabs">
					<div class="innerTabs">
						<div v-for="(tab,index) in tabName" class="tab-item" :class="{active:curIndex === index}" @click="tabHeadClicked(index,tab)"><span>{{tab}}</span></div>
					</div>
				</div>
				<div id="btnDownL" class="btn2" @mousedown="btmMouseDown" @mouseup="btmMouseUp" data-toggle="tooltip" data-placement="top" title="下移"></div>
			</div>
			<div class="tab-body tab-search">
				<div class="tab-content" id="myWeek" v-loading="loadTree" element-loading-text="加载中">
					<div class="tab-bar">
						<div class="track_top_btn02"   >
							<i class="dropdown" style="display:inline-block;" v-show="curIndex===0">
								<button v-if="permission.indexOf('vehicleMonitor_branch') == -1" class="btn ico_04" data-toggle="dropdown" :disabled="unableG">分支</button>
								<ul class="dropdown_menu list-group list01">
									<li class="list_group_item" @click="addNode">新建分支</li>
									<li class="list_group_item" @click="editNode" v-show="!unableGroup">编辑分支</li>	
									<li class="list_group_item" @click="deleteNode" v-show="!unableGroup">删除分支</li>	
								</ul>
							</i>
							<i class="dropdown" style="display:inline-block;" v-show="curIndex===0">
								<button v-if="permission.indexOf('vehicleMonitor_move') == -1" class="btn ico_05" data-toggle="dropdown" :disabled="unableM">移动</button>
								<ul class="dropdown_menu list-group list01">
									<li class="list_group_item" @click="moveNode" v-show="!unableG">移动分支</li>
									<li class="list_group_item" @click="checkMode"><input type="checkbox" id="check-mode" :checked="checkable"/>复选模式</li>
									<li class="list_group_item" @click="moveVehicle"><button class="btn" :disabled="!checkable" style="margin:0;padding:0;">移动已选车辆</button></li>		
								</ul>
							</i>
							<i><button class="ico_06 btn" @click="hideAll" :disabled="searchMode">全部收起</button></i>
						</div>
						<div class="track_bottom_btn02">
							<p>
								<i>目标：
									<span><input type="radio" v-model="searchType" value="1" name="s"/>车辆</span>   
									<span><input type="radio" v-model="searchType" value="2" name="s"/>分支</span>
								</i>
								<i>范围：{{searchArea}}</i>
							</p>
							<p class="pp_input">
								<!--<input type="text" :placeholder="searchType==0?'服务号，车牌号':'分支名称'" v-model="searchInput"/>-->
								<input type="text" class="tip" v-model="searchInput" :disabled="searchMode" :placeholder="searchType==1?'车牌号,手机号':'分支名称'" data-toggle="tooltip" data-placement="top"  data-html="true" :title="searchRemind" :tip="searchRemind"/>
								<button class="btn btn-primary" v-if="!searchMode" @click="toSearch" :disabled="searchInput==''">查询</button>
								<button class="btn btn-danger" v-else @click="stopSearch">取消</button>
							</p>
						</div>		
						<div class="tab-row car_status" v-if="curIndex === 0">
							<ul>					
								<tree-node v-for="(node,index) in tree1"  :key="index"
									:checkable="checkable"
						    		ref="treenode"
						    		:node="node"			
						    		:showCheckbox="true"
						    		:index="index"
						    		:curTreeIndex="curIndex"
						    		:searching="searching"
						    		:searchType="searchType"
						    		v-on:toggleChild="handleToggle"
						    		v-on:refreshNode="handleRefresh"
						    		v-on:srchRefresh="handleSrchRefresh"
						    		:isCarMoved="isCarMoved"
						    		:treeType="0"
						    		:searchInput="searchInput"
						    		:show1="true"
						    		:nodeClickedId = "nodeClickedId"
						    		@click="handleClick"				    		
						    		@check="handleCheck">
						    	</tree-node>
							</ul>
						</div>
						<div class="tab-row car_status" v-if="curIndex === 1">
							<ul>					
								<tree-node v-for="(node,index) in tree2"  :key="index"
						    		ref="treenode"
						    		:node="node"			
						    		:showCheckbox="true"
						    		:index="index"
						    		:curTreeIndex="curIndex"
						    		v-on:toggleChild="handleToggle"
						    		v-on:refreshNode="handleRefresh"
						    		v-on:srchRefresh="handleSrchRefresh"
						    		:searching="searching"
						    		:treeType="1"
						    		:searchInput="searchInput"
						    		:nodeClickedId = "nodeClickedId"
						    		@click="handleClick"				    		
						    		@check="handleCheck">
						    	</tree-node>
							</ul>
						</div>
						<div class="tab-row car_status" v-if="curIndex === 2">
							<ul>					
								<tree-node v-for="(node,index) in tree3"  :key="index"
						    		ref="treenode"
						    		:node="node"			
						    		:showCheckbox="true"
						    		:index="index"
						    		:curTreeIndex="curIndex"
						    		v-on:toggleChild="handleToggle"
						    		v-on:refreshNode="handleRefresh"
						    		v-on:srchRefresh="handleSrchRefresh"
						    		:searching="searching"
						    		:searchInput="searchInput"
						    		:treeType="2"
						    		:nodeClickedId = "nodeClickedId"
						    		@click="handleClick"				    		
						    		@check="handleCheck">
						    	</tree-node>
							</ul>
						</div>	
						<div class="tab-row car_status" v-if="curIndex === 3">
							<ul>					
								<tree-node v-for="(node,index) in tree4"  :key="index"
						    		ref="treenode"
						    		:node="node"			
						    		:showCheckbox="true"
						    		:index="index"
						    		:curTreeIndex="curIndex"
						    		v-on:toggleChild="handleToggle"
						    		v-on:refreshNode="handleRefresh"
						    		v-on:srchRefresh="handleSrchRefresh"
						    		:searching="searching"
						    		:searchInput="searchInput"
						    		:treeType="3"
						    		:nodeClickedId = "nodeClickedId"
						    		@click="handleClick"				    		
						    		@check="handleCheck">
						    	</tree-node>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 车辆监控页面_左侧车辆列表模块结束  -->
		<!--TabModal组件开始--点击主面板-分支弹窗-->
		<tab-modal ref="modalDel"  size="small" title="删除分支" v-on:cancel="closeModal">
			<div>
				<p v-if="showWithdraw">您将删除名为{{clickedNode.name}}的分支，您确定继续吗？</p>
				<p v-else>您将要删除的分支{{clickedNode.name}}中尚有车辆信息，不能删除</p>
			</div>
			<div slot="footer">
				<button v-if="showWithdraw" class="btn btn-primary" @click="withdrawDel">取消</button>
				<button class="btn btn-primary" @click="confirmDel">确定</button>
			</div>	
		</tab-modal>
		<!--新建、编辑时的弹框-->
		<tab-modal ref="modalSave"  size="small" :title="saveTitle" v-on:cancel="closeModal">
			<div>
				<div class="form-group">
						<label class="control-label">分支名称</label>
						<input type="text" class="form-control" v-model="newNodeName">
				</div>
				<br/>
				<div class="form-group">
						<label class="control-label">顺序号</label>
						<input type="text" class="form-control" v-model="editOrderNo">
				</div>
			</div>	
			<div slot="footer">
				<button class="btn btn-primary" @click="saveSubBtn">保存</button>
			</div>
		</tab-modal>
		<!--TabModal组件开始--点击主面板-移动-移动分支弹窗-->
		<tab-modal ref="modalMGroup" size="normal" title="移动分支" v-on:cancel="closeModal"  class="vehicle_group_box">	
				<div v-show="firstStep">
					<div class="form-group">
						<label class="control-label">需要移动的分支：</label>
						<input type="text" class="form-control" readonly :value="oriOrg" />
					</div>
					<div class="form-group">
						<label class="control-label">将上述分支移动至以下分支之内：</label>
						<div class="col-sm-12">
							<customer-tree
								ref="vehTree"
								v-model="targetNodeId"
								url="/monitor/tree/groups/"
								:para="{'exGroupId':this.nodeClickedId,'showTreeType':this.curIndex}"
								:setting="settingG"
								v-on:onerror="onerror1"
								:isTreeInit="isTreeInit"
								> 
							</customer-tree>
						</div>  
					</div>
				</div>
				<div v-show="!firstStep">
					<p class="control-label">您即将把{{oriOrg}}分支（共包含{{nodeCount}}辆车）移动至{{targetNodeName}}分支的<span style="font-weight: bold;">下一级</span>。您确定要继续操作吗？</p>
				</div>
				<div slot="footer">
					<button class="btn btn-primary" @click="withdrawSubBtn">取消</button>				
					<button class="btn btn-primary" @click="confirmSubBtn">确定</button>
				</div>				
		</tab-modal>
		<!--TabModal组件开始--点击主面板-移动-移动已选车辆弹窗-->
		<tab-modal ref="modalMCar" size="normal" title="移动车辆" v-on:cancel="closeModal"  class="vehicle_group_box">	
				<div v-show="firstStep2" class="form-group">
					<p>您已经在{{checkedNodeL}}个分支中，共选择了{{checkedVeObj.length}}台车辆。即将把上述车辆全部移动至以下分支之内：</p>
					<div class="col-sm-12">
						<customer-tree
							ref="vehTree2"
							v-model="selectedVehicleId"
							url="/monitor/tree/groups/"
							:para="{'showTreeType':this.curIndex}"
							:setting="setting"
							v-on:onerror="onerror2"
							:isTreeInit="isTreeInit2"
							> 
						</customer-tree>
					</div> 
				</div>
				<div v-show="!firstStep2">
					<p>您即将把{{checkedNodeL}}个分支中的共{{checkedVeObj.length}}台车辆移动至 {{selectedVehicleName}}分支内。您确定要继续操作吗？</p>
				</div>
				<div slot="footer">
					<button class="btn btn-primary" @click="withdrawSubBtn2">取消</button>				
					<button class="btn btn-primary" @click="confirmSubBtn2" >确定</button>
				</div>				
		</tab-modal>
		<!--TabModal组件结束-->
	</div>
</template>
<script>
	import {required} from 'vuelidate/lib/validators'
	import {mapState} from 'vuex'
	import {Mixin} from './mixin.js'
	import {tipMixin} from 'util/util'
	import {treeMixin} from 'components/common/Tree/mixin.js'
	import TreeNode from "components/common/Tree/TreeNode"
	import TabModal from 'components/common/TabModal'
	import {OPERATE_EXCEPTION} from 'static/message.js'
	/*和组织机构树相关*/
	import CustomerTree from "components/common/CustomerTree"  
	export default {
		name: 'TabSearch',
		mixins:[Mixin,treeMixin,tipMixin],
		components: {
			TreeNode,
			TabModal,
			CustomerTree
		},
		validations:{
			selectedNode:{
				required
			},
			targetNode:{
				required
			}
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["vehicleMonitor"]?this.$store.state.permission.permission["vehicleMonitor"]:[],
				/*
				 * 面板渲染有关
				 * */
			//	tabName:['主面板','在线','暂停接单','未定位','等待接单','停车中','停车超时','当日超速','紧急预警','驻防中','已接单'],
				tabName:['主面板','空闲中','已暂停','救援中'],
				curIndex:0, //当前tab索引
				cArr:[],	//当前面板下的树分支
				tabTitle:'主面板',	
				searchRemind:'<span style="left:0">车牌号,手机号</span>',
				/*
				 * tree渲染有关
				 * */
				treeTmp:[],
				tree1: [],
				tree2:[],
				tree3:[],
				tree4:[],
				searching:true,
				searchMode:false, //默认非快速查询模式
				isCarMoved:false,
				unableG:true,	 //主面板的分支、
				unableGroup:true,//组织机构type=1的时候不可编辑和删除
				unableM:true,    //移动按钮是否可点击
				nodeClickedId:0, //被点击的分支id 
				toggleNodeId:[], //被收缩的分支id
			//	openCheckMode:false,//是否开启复选框模式（true:车辆分支上显示复选框，移动已选车辆可以使用）
				checkable:false,	//是否显示复选框==控制车辆分支复选框是否可用
				/*
				 * 各面板初始化tree的参数
				 * */
				param:{
					groupId:'1',
					isCustomerType:true,
					treeType:0
				},
				/*
				 * 弹框1--新建、编辑分支
				 * */
				saveTitle:'编辑分支',//根据操作类型改变名称
				clickedNode:{},//点击的非车辆分支
				pNode:{},//被点击的非车辆分支父分支
				clickedIndex:0,//被点击的非车辆分支的index
				//弹框2--删除分支
				showWithdraw:false,//是否显示取消按钮
				//编辑
				newNodeName:'',//被编辑分支的新机构名称
				editOrderNo:'',//被编辑分支的orderNo
				/*
				 * 弹框2和3--移动分支或已选车辆
				 * */ 
				//弹框2-移动分支 
				firstStep:true,  //移动中的第一步
				isTreeInit:false, 
				oriOrg:'',		//被移动分支名称
				enterNode:[],	 //目标分支下拉框数组 
				targetNodeName:'',//目标分支名称
				targetNodeId:'',//目标分支id
				nodeCount:0,	//被移动的分支下包含的车辆分支数量
				//弹框3-移动已选车辆 
				firstStep2:true,  //移动中的第一步
				isTreeInit2:false,
				checkedNodeL:[], 
				selectedVehicleName:'',//目标分支名称
				selectedVehicleId:'',//目标分支id
				settingG:{
					data: {
		                simpleData: {
		                    enable: true,
		                    idKey: "id",
							pIdKey: "pId"
		                }
		           },
		           view: {
				        dblClickExpand: false,
				        selectedMulti: false,
				        autoCancelSelected: true
				    },
				    callback: {
				        onClick: this.onGroupClick
				    }
				}, 
				setting:{
					data: {
		                simpleData: {
		                    enable: true,
		                    idKey: "id",
							pIdKey: "pId"
		                }
		           },
		           view: {
				        dblClickExpand: false,
				        selectedMulti: false,
				        autoCancelSelected: true
				    },
				    callback: {
				        onClick: this.onClick
				    }
				},
				//底部快速查询
				searchArea:'所有',
				searchType:'1',	//快速查询类型  1车辆  2分支
				rollUp:false, //是否收起面板
				leafCount:0,
				//快速查询时，input输入的查询内容
				searchInput:'',
				/*
				 企业分支上的操作-刷新
				 * */
				//刷新
				refreshedNode:{}  //被刷新的分支节点
			}
		},
		computed:{
			...mapState({
				loadTree:state=>state.monitor.loadTree,
				checkedVehicle:state=>state.monitor.checkedVehicle,//移动车辆时使用-选中的车辆分支id
				groupId:state=>state.user.groupid,
				checkedVeObj:state=>state.monitor.checkedVeObj,//选中的车辆分支信息--计算选中的车辆在几个分支下
				magnify:state=>state.monitor.magnify, //面板处于缩小状态，可以点击放大
				leftSize:state=>state.monitor.leftSize
			}),
			isDisable:function(){
				return this.$v.targetNode.required
			}
		},
		watch:{  
			searchType(val){
				if(val==0){
					this.searchRemind = '<span style="left:0">车牌号,手机号</span>'
					this.updateTip()
				}else{
					this.searchRemind = '分支名称'
					this.updateTip()
				}
			},
			curIndex:function(val){//tab切换时请求获取对应的tree
				const self = this;
				switch(val){
					case 0:
						this.param.treeType='0'
						this.searchArea = '所有'
						break;
					case 1:
						this.param.treeType='1'
						this.searchArea = '空闲中'
						break;	
					case 2:
						this.param.treeType='2'
						this.searchArea = '已暂停'
						break;
					case 3:
						this.param.treeType='3'
						this.searchArea = '救援中'
						break;	
					default:
						break;
				}
				this.getTreeData(self.param) 
			},
			checkedVeObj:function(val){
				let count = 1;
				if(val.length!=0){
					for(let i = 0,length=val.length - 1;i<length;i++){
						if(val[i].pId!=val[i+1].pId){
							count++
						}
					}
					this.checkedNodeL = count;
				}
			}
		},
		mounted() {//1，tab初始化
			this.param.groupId = this.groupId
			this.getTreeData(this.param)
			$(function () {//启用tooltip
			  $('[data-toggle="tooltip"]').tooltip()
			})
		},
		destroyed(){
			$('[data-toggle="tooltip"]').tooltip('hide')
		},
		methods: {
			//2，显示分支
			getTreeData(param){
				this.$store.dispatch('loadTreeList',true)///rescue-api/monitor/rescues/vehicles/tree
				this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/monitor/rescues/vehicles/tree',{params:param})
			//	this.$http.get('../../../../static/rescueOrder/rescuecarlist.json')
				.then((response) => {
					if(response.body.success){
						this.tree1 = null
						this.tree2 = null
						this.tree3 = null
						this.tree4 = null 
						let mountDate = new Date();
						this.$store.dispatch('saveMountTime',mountDate)
						if(!response.body.data) return
						this.treeTmp = response.body.data; 
						if(this.treeTmp.length > 0){
							for(let i = 0,length = this.treeTmp.length; i < length; i ++){
								if(i > 0){
									this.treeTmp[i].isShow = false
								} 
							} 
							let firstPID = this.treeTmp[0].pId
								const self = this;
							var tree = this.listToTree(self.treeTmp, firstPID,{
								idKey: 'id',
								parentKey: 'pId',
								childrenKey: 'children'
							})
							this.setTreeData(tree)
						}
						
						this.$store.dispatch('loadTreeList',false)
						
					}else{
						this.$store.dispatch('loadTreeList',false)
						this.$store.dispatch('tipModalShow',response.body.message)
					}
				},(response)=>{
					this.$store.dispatch('loadTreeList',false)
					this.$store.dispatch('tipModalShow',response.body.message)
				})
				.catch((response)=>{
					console.log(response)
					this.$store.dispatch('loadTreeList',false)
					this.$store.dispatch('tipModalShow',OPERATE_EXCEPTION)
				})
			},
			//设置数据
			setTreeData(tree){
				switch (this.curIndex){
							case 0:
								this.$set(this, "tree1", tree);
								break;
							case 1:
								this.$set(this, "tree2", tree);
								break;
							case 2:
								this.$set(this, "tree3", tree);
								break;
							case 3:
								this.$set(this, "tree4", tree);
								break;	
							default:
								break;
					}
			},
			//4，某一面板的树分支初始化
			initTabSearch(treeType){
				this.param.groupId = this.groupId
				this.param.treeType = treeType
				this.getTreeData(this.param)
			},
			//5,主面板分支功能
			/**
			 * 点击节点时钩子
			 * 参数1：当前结点
			 */
			handleClick(obj) {
				this.nodeClickedId = obj.cNode.id; //点击的分支id
				this.clickedNode = obj.cNode;	//被点击的分支
				this.editOrderNo = obj.cNode.orderNo; //被编辑的分支顺序号
				this.pNode = obj.pN;		
				this.clickedIndex = obj.index;
				if(obj.cNode.type!=2){
					this.unableM = false;
					this.unableG = false;
					if(obj.cNode.type==1){
						this.unableGroup = true
					}else{
						this.unableGroup = false
					}
					this.oriOrg = obj.cNode.name
					this.nodeCount = obj.cNode.amount
				}else{
					this.unableG = true;
				//	this.handleMapTab()
				}
			},
			handleMapTab(){
				//添加车辆详情tab在右侧动态悬浮框里
					const param = {
						id:'VehicleDetail',
						No:6,
						name:'车辆详情'
					}
					this.$store.dispatch('loadingTabMap',true)
					this.$store.dispatch('addMapTab',param)
					//获取车辆节点信息渲染到车辆详情面板
					this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/' + this.nodeClickedId)
	        		.then((res)=>{
	        			if(res.body.success){
	        				this.$store.dispatch('loadingTabMap',false)
	        				const vInfo = res.body.data;
	        				this.$store.dispatch('addVehicleDetail',vInfo)
	        			}
	        		},(res)=>{
	        			this.$store.dispatch('loadingTabMap',false)
	        			this.$store.dispatch('tipModalShow',response.body.message)
	        		})
	        		.catch((res)=>{
	        			this.$store.dispatch('loadingTabMap',false)
	        			this.$store.dispatch('tipModalShow',response.body.message)
	        		})
			},
			//5--1，新建分支
			addNode(){
				this.saveTitle = '新建分支'
				this.moveN = false;
				this.moveV = false;
				this.isCarMoved = false;
				this.newNodeName = '';
				this.$refs.modalSave.open()
			},
			//5--2，编辑分支
			editNode(){
				if(this.clickedNode.type==0){
					this.saveTitle = '编辑分支'
					this.newNodeName = this.clickedNode.name
					this.moveN = false;
					this.moveV = false;
					this.isCarMoved = false;
					this.$refs.modalSave.open()
				}else if(this.clickedNode.type==1){//选中组织机构
					this.$store.dispatch('tipModalShow','组织机构节点不能进行编辑，请选择车辆分支')
				}else{
					this.$store.dispatch('tipModalShow','车辆节点不能进行编辑，请选择车辆分支')
				}
			},
			saveSubBtn(){//编辑/新建分支点保存
				if(this.saveTitle=='新建分支'){
					const param = {
						parentGroupId:this.clickedNode.id,
						groupName:this.newNodeName,
						orderNo:this.editOrderNo,
						set:[1,2,3,4]
					}
					this.saveNewTree(param)
				}else if(this.saveTitle=='编辑分支'){
					const param = {
						groupId:this.clickedNode.id,
						groupName:this.newNodeName,
						orderNo:this.editOrderNo
					}
					this.saveEditTree(param)
				}
				this.$refs.modalSave.close()
			},
			saveNewTree(param){//调新建保存接口
				let str = JSON.stringify(param)
				//'/monitor/group/groups',param
				//'/monitor/group/groups?parentGroupId=' + param.parentGroupId + '&groupName=' + param.groupName + '&orderNo=' + param.orderNo + '&set=' + param.set
				this.$http.post(process.env.API_ROOT + '/monitor/group/groups?parentGroupId=' + param.parentGroupId + '&groupName=' + param.groupName + '&orderNo=' + param.orderNo + '&set=' + param.set)
				.then((response) => {
					if(response.body.success){
						this.isCarMoved = true;
						this.initTabSearch('0')
						this.newNodeName = ''
						this.$store.dispatch('tipModalShow','新建分支成功')
					}else{
						this.$store.dispatch('tipModalShow',response.body.message)
					}
				},(response)=>{
					this.$store.dispatch('tipModalShow',response.body.message)
				})
				.catch((response)=>{
					this.$store.dispatch('tipModalShow',response.body.message)
				})
			},
			saveEditTree(param){//调编辑保存接口//'/monitor/group/groups',param
				//'/monitor/group/groups?groupId=' + param.groupId + '&groupName=' + param.groupName + '&orderNo=' + param.orderNo
				this.$http.put(process.env.API_ROOT + '/monitor/group/groups?groupId=' + param.groupId + '&groupName=' + param.groupName + '&orderNo=' + param.orderNo
				)
				.then((response) => {
					if(response.body.success){
						this.initTabSearch('0')
						this.isCarMoved = true;
						this.newNodeName = ''
						this.$store.dispatch('tipModalShow','编辑分支成功')
					}else{
						this.$store.dispatch('tipModalShow',response.body.message)
					}
				},(response)=>{
					this.$store.dispatch('tipModalShow',response.body.message)
				})
				.catch((response)=>{
					this.$store.dispatch('tipModalShow',response.body.message)
				})
			},
			//5--3,删除分支
			deleteNode(){ 
				this.showWithdraw = true;
				this.isCarMoved = false;
				if(this.clickedNode.amount != 0){//点删除分支且分支下有车辆
					this.showWithdraw = false;//不能删除
				}
				this.$refs.modalDel.open()
			},
			withdrawDel(){//删除分支点取消
				this.$refs.modalDel.close() 
			},
			confirmDel(){//删除分支弹框点确认
				if(this.showWithdraw){//点删除分支且分支下无车辆
						const self = this
						this.delTreeData(self.nodeClickedId)
						this.showWithdraw = false;
				}
				this.$refs.modalDel.close()
			},
			delTreeData(id){
				this.$http.delete(process.env.API_ROOT + '/monitor/group/groups/' + id)
				.then((response) => {
					if(response.body.success){
						this.initTabSearch('0')
						this.isCarMoved = true;
						this.$store.dispatch('tipModalShow','删除成功')
					}else{
						this.$store.dispatch('tipModalShow',response.body.message)
					}
				},(response)=>{
					this.$store.dispatch('tipModalShow',response.body.message)
				})
				.catch((response)=>{
					this.$store.dispatch('tipModalShow',response.body.message)
				})
			},
			//6，移动操作
			//6--1 移动分支
			moveNode(){
				const param = {
					exGroupId:this.nodeClickedId,
					showTreeType:this.curIndex
				}
				this.isCarMoved = false;
				this.targetNodeId = ''
				this.$refs.vehTree.reSet();
				this.isTreeInit = true;
				this.firstStep = true;
				this.$refs.vehTree.getTree()
				this.$refs.modalMGroup.open()
			},
			//6--2,移动已选车辆
			checkMode(){//点击菜单而非复选框时也选中复选框
				if(this.checkable){
					this.checkable =false
				}else{
					this.checkable = true;
				}
			},
			handleCheck(obj,pNode){
				if(obj.checked){//获取选中的车辆分支
					this.$store.dispatch('checkVehicle',obj)
				}else{//取消选中后的车辆分支
					this.$store.dispatch('removeVehicle',obj)
				}
			},
			moveVehicle(){
				if(!this.checkable){//非复选框模式不可点击
					return
				}
				if(this.checkedVeObj.length == 0){//没有选择车辆不可点击
					this.$store.dispatch('tipModalShow','请选择要移动的车辆')
					return
				} 
				const param = {
				//	exGroupId:this.nodeClickedId,
					showTreeType:this.curIndex
				} 
				this.selectedVehicleId = ''
				this.$refs.vehTree2.reSet()
				this.isTreeInit2 = true;
				this.$refs.vehTree2.getTree()
				this.isCarMoved = false;
				this.$refs.modalMCar.open()
				this.firstStep2 = true;
			}, 
			confirmSubBtn(){ 
				if(this.targetNodeId == ''){
					this.$store.dispatch('tipModalShow','请选择要移入的分支')
					return
				}
				if(this.firstStep){
					this.firstStep = false; 
					this.targetNodeName = this.$refs.vehTree.queryGroup
				}else{
					const param = {
						isCustomerType:1,
						oriGroupId:this.nodeClickedId + '',
						tagGroupId:this.targetNodeId + ''
					}
					this.moveGroupTree(param)
					this.$refs.modalMGroup.close()
					this.firstStep = true;
				} 
			},
			confirmSubBtn2(){
				if(this.selectedVehicleId == ''){
					this.$store.dispatch('tipModalShow','请选择要移入的分支')
					return
				}
				if(this.firstStep2){
					this.firstStep2 = false;
					this.selectedVehicleName = this.$refs.vehTree2.queryGroup
				}else{ 
					let checkedVe = []
					this.checkedVeObj.map(item=>{
						checkedVe.push(item.id)
					})
					const param = {
						vehicleIds:checkedVe,
						tagGroupId:this.selectedVehicleId
					} 
					this.moveCarTree(param)
					this.$refs.modalMCar.close()
					this.firstStep = true;
				}
			},
			moveGroupTree(param){
				this.$http.post(process.env.API_ROOT + '/monitor/move/group/?isCustomerType='+param.isCustomerType+'&oriGroupId='+param.oriGroupId+'&tagGroupId='+param.tagGroupId)
				.then((response) => {
					if(response.body.success){
						this.$store.dispatch('tipModalShow','移动分支成功')
						this.initTabSearch('0')
						this.isCarMoved = true;
						this.nodeClickedId = 0;
					}else{
						this.$store.dispatch('tipModalShow',response.body.message)
					}
				},(response)=>{
					this.$store.dispatch('tipModalShow',response.body.message)
				})
				.catch((response)=>{
					this.$store.dispatch('tipModalShow',response.body.message)
				})
			},
			moveCarTree(param){
				//'/monitor/move/group/vehicles',param
				//'/monitor/move/group/vehicles?tagGroupId=' + param.tagGroupId,arr
				const arr = param.vehicleIds
				this.$http.post(process.env.API_ROOT + '/monitor/move/group/vehicles?tagGroupId=' + param.tagGroupId,arr)
				.then((response) => {
					if(response.body.success){
						this.$store.dispatch('tipModalShow','移动车辆成功')
						this.isCarMoved = true;
						this.checkable = false;
						this.initTabSearch('0')
						this.nodeClickedId = 0;
						//取消所有车辆选中状态
						this.$store.dispatch('clearChecked')
					}else{
						this.$store.dispatch('tipModalShow',response.body.message)
					}
				},(response)=>{
					this.$store.dispatch('tipModalShow',response.body.message)
				})
				.catch((response)=>{
					this.$store.dispatch('tipModalShow',response.body.message)
				})
			},
			withdrawSubBtn(){//取消操作
				if(!this.firstStep){//从第二步到第一步不能去掉弹框
						this.firstStep = true; 
						this.selectedVehicleId = ''
				}else{
					this.$refs.modalMGroup.close() 
				} 
			},
			withdrawSubBtn2(){//取消移动车辆
				if(this.firstStep2){
					this.$refs.modalMCar.close()
					//取消所有车辆选中状态
					this.$store.dispatch('clearChecked')
					this.checkable = false;
					this.nodeClickedId = 0;
				}else{
					this.firstStep2 = true
					this.selectedVehicleId = ''
				}
			},
			closeModal(){ 
				this.firstStep2 = true
				this.firstStep = true
				this.showWithdraw = true
				//取消所有车辆选中状态
				this.$store.dispatch('clearChecked')
				this.checkable = false;
				this.nodeClickedId = 0;
				this.$refs.modalSave.close()
				this.$refs.modalDel.close()
				this.$refs.modalMGroup.close()
				this.$refs.modalMCar.close()
				
			},
			//和移动分支时的分支树相关------------------
			onerror1(msg){
				this.$store.dispatch('tipModalShow',msg)
			}, 
			//和移动车辆时的分支树相关------------------
			onerror2(msg){
				this.$store.dispatch('tipModalShow',msg)
			},
			//7,查询分支
			toSearch(){//开始查询
				if (this.searchInput==""){
					return;
				}
				this.isCarMoved = false;
				//TODO:使用新搜索查询接口
				this.$store.dispatch('loadTreeList',true)
					const paramObj = {
						param:this.searchInput,
						searchType:this.searchType,
						treeType:this.curIndex
					}
					this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/monitor/rescues/vehicles/tree/search',{params:paramObj})
					.then((response) => {
						if(response.body.success ){
							this.$store.dispatch('loadTreeList',false)
							if(!response.body.data) return
							if(response.body.data.length > 0){
								this.searching = false;//不显示分支数
								this.treeTmp = response.body.data;
								for(let i = 0,length = this.treeTmp.length; i < length; i++){
									this.treeTmp[i].isShow = true;//每个分支节点都展开
								}
								let firstPID = this.treeTmp[0].pId
								var tree = this.listToTree(this.treeTmp,firstPID, {
									idKey: 'id',
									parentKey: 'pId',
									childrenKey: 'children'
								})
								this.setTreeData(tree)
								this.searchMode = true;
							}else{
								this.$store.dispatch('tipModalShow','无符合条件的信息')
							}
						}else{
							this.$store.dispatch('loadTreeList',false)
							this.$store.dispatch('tipModalShow',response.body.message)
						}
					},(response)=>{
						this.$store.dispatch('loadTreeList',false)
						this.$store.dispatch('tipModalShow',response.body.message)
					})
					.catch((response)=>{
						console.log(response)
						this.$store.dispatch('loadTreeList',false)
						this.$store.dispatch('tipModalShow',OPERATE_EXCEPTION)
					}) 
			},
			stopSearch(){//取消查询
				this.searchMode = false;
				this.searching = true;//不查询模式的时候显示amount
				const treeType = this.curIndex + ''
				this.searchInput = ''
				this.initTabSearch(treeType)//初始化分支树
				this.$refs.treenode[0].node.isShow = true
				this.isCarMoved = true
			},
			handleToggle(obj){
				let refArr = []
				this.cArr = []
				let arr = this.$refs.treenode[0].$children
				for(let i = 0,length = arr.length; i < length; i ++){
					this.cArr.push(arr[i])
				}
				this.getAllNode(arr)
				refArr = this.cArr
				for(let i = 0,length = refArr.length;i<length;i++){
				    if(refArr[i].node.pId == obj.id){
				    	refArr[i].show =false;
				    }
				}
			},
			//快速查询模式下点分支刷新-重新调用快速查询接口
			handleSrchRefresh(){
				this.toSearch()
			},
			handleRefresh(obj){
				if(obj.id == this.groupId){//点根节点的刷新
					this.hideAll()
				}else{
					let refArr = []
					this.cArr = []
					let arr = this.$refs.treenode[0].$children
					for(let i = 0,length = arr.length; i < length; i ++){
						this.cArr.push(arr[i])
					}
					this.getAllNode(arr)
				    refArr = this.cArr
				    for(let i = 0,length = refArr.length;i<length;i++){
				    	if(refArr[i].node.pId == obj.id){
				    		refArr[i].show =false;
				    	}
					}
				}
			},
			getAllNode(arr){
				for(let j = 0,length = arr.length; j < length; j ++){
					if(arr[j].$children.length !== 0){
						this.getAllNode(arr[j].$children)
						let tmpArr = arr[j].$children
						for(let k = 0,length = tmpArr.length; k < length; k ++){
							this.cArr.push(tmpArr[k])
						}
					}
				}
				return this.cArr
			},
			//8，全部收起
			hideAll(){ 
				let vComp = this.$refs.treenode
				if(vComp.length > 0){
					let refArr = []
					let arr = vComp[0].$children
					for(let i = 0,length = arr.length; i < length; i ++){
						this.cArr.push(arr[i])
					}
					this.getAllNode(arr)
				    refArr = this.cArr
					for(let i = 0,length = refArr.length;i<length;i++){
						refArr[i].show =false;
					}
				} 	
			},
        	/*
        	 面板操作
        	 * */
        	// 隐藏主面板
			hidePanel(){
				if(this.leftSize==0){//最小
					this.$store.dispatch('changeLeftSize',1)
				}else if(this.leftSize == 1){//半高
					this.$store.dispatch('changeLeftSize',2)
				}else{//最大
					this.$store.dispatch('changeLeftSize',0)
				} 
			}, 
			//放大面板
			toMagnify(){
				this.$store.dispatch('magnifyTree',true)
			},
			//缩小面板
			toShrink(){
				this.$store.dispatch('magnifyTree',false)
			}, 
			//tab切换
			goTab(index,tab){
				this.tabHeadClicked(index,tab)
			},
			tabHeadClicked(index,tab){
				if(this.searchMode){
					this.stopSearch()
				}else{
					this.searching = true;//不查询模式的时候显示amount
				}
				this.curIndex = index;
				this.tabTitle = tab;
				this.searchInput = ''
				this.nodeClickedId = 0;
				this.hideAll()
			},
			//左侧上下滚动
			topMouseDown(){
				this.handleTopMouseD('.tab-vertical-left','.tab-item')
			},
			topMouseUp(){
				this.handleMouseUp('.tab-vertical-left')
			},
			btmMouseDown(){
				this.handleBtmMouseD('.tab-vertical-left','.tab-item')
			},
			btmMouseUp(){
				this.handleMouseUp('.tab-vertical-left')
			}
		}
	}			
</script>
<style scoped lang="scss">
	#check-mode{
		margin:0 4px 0 0;
		vertical-align:middle;
	} 
	.menuInput{
		position:relative;
	}
	.vehicle_group{
		position:absolute;
		top:31px;
		left:6px;
		border:1px solid #ddd;
		z-index:999; 
	} 
</style>




// WEBPACK FOOTER //
// TabSearch.vue?c53c2512